export default __webpack_public_path__ + "static/s01-10bc4702eb23a65bc6c5a4c42b85ddca.png";